if (!customElements.get('back-to-top')) {
	customElements.define('back-to-top', class ButtonScrollTop extends HTMLElement {
		connectedCallback() {
			this.button = this.querySelector('.back-to-top');

			if (!this.button || this.dataset.bound === 'true') {
				return;
			}

			this.dataset.bound = 'true';
			this.ticking = false;
			this.threshold = 450;

			this.onScroll = this.onScroll.bind(this);
			this.updateVisibility = this.updateVisibility.bind(this);

			window.addEventListener('scroll', this.onScroll, { passive: true });
			this.updateVisibility();

			this.button.addEventListener('click', (event) => {
				event.preventDefault();
				this.handleClick();
			});
		}

		disconnectedCallback() {
			window.removeEventListener('scroll', this.onScroll);
		}

		onScroll() {
			if (this.ticking) {
				return;
			}

			this.ticking = true;
			window.requestAnimationFrame(() => {
				this.updateVisibility();
				this.ticking = false;
			});
		}

		getScrollY() {
			return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
		}

		updateVisibility() {
			if (!this.button) {
				return;
			}

			if (this.getScrollY() > this.threshold) {
				this.button.classList.add('back-to-top-visible');
			} else {
				this.button.classList.remove('back-to-top-visible');
			}
		}

		handleClick() {
			document.documentElement.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
	});
}
